import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
// import { DataTableModule } from "ng-angular8-datatable";
// import { MyDatePickerModule } from "mydatepicker";
// import { Ng5SliderModule } from "ng5-slider";
// import { TooltipModule } from "ng2-tooltip-directive";
import { NgChartsModule } from "ng2-charts";
import { AppCommonModule } from "@common/common.module";
// import {
//   SwiperModule,
//   SwiperConfigInterface,
//   SWIPER_CONFIG,
// } from "ngx-swiper-wrapper";
// import { HighchartsChartModule } from "highcharts-angular";
// import { AgmCoreModule } from "@agm/core";

import { ComponentRoutingModule } from "./component-routing.module";
import { ProductsComponent } from "./products/products.component";
import { ContactUsComponent } from "./contact-us/contact-us.component";
import { LoginComponent } from "./pop-ups/login/login.component";
import { NavDividendsComponent } from "./nav-dividends/nav-dividends.component";
import { KnowledgeCenterComponent } from "./knowledge-center/knowledge-center.component";
import { DownloadsComponent } from "./downloads/downloads.component";
import { CareersComponent } from "./careers/careers.component";
import { BranchesComponent } from "./branches/branches.component";
import { VideoPopUpComponent } from "./product-details/video/video-pop-up/video-pop-up.component";
import { NfoComponent } from "./nfo/nfo.component";
import { ArticleDetailsComponent } from "@component/ceo-desk/articles/article-details.component";
import { ArticleDetailsMobileComponent } from "@component/ceo-desk/articles/article-details-mobile.component";
import { LatestNewsComponent } from "./latest-news/latest-news.component";
import { MediaComponent } from "./media/media.component";
// import { RemunerationDialogComponent } from "@component/key-policies/statuory/remuneration-dialog/remuneration-dialog.component";
import { ApplyJobDialogComponent } from "./careers/apply-job-dialog/apply-job-dialog.component";

import { LifeAtXyzComponent } from "./careers/life-at-xyz/life-at-xyz.component";
import { KeyPolicyModule } from "./key-policies/key-policy.module";
import { PopUpsModule } from "./pop-ups/pop-ups.module";
import { GrowthMenuComponent } from "./products/growth-menu/growth-menu.component";
// import { environment } from "../../environments/environment";
import { InterviewsComponent } from "@component/ceo-desk/interviews/interviews.component";
import { AdvertisementComponent } from './advertisement/advertisement.component';
import { CeoLibraryComponent } from '@component/ceo-desk/ceo-library/ceo-library.component';
import { NfoVedioPopUpComponent } from './nfo/nfo-vedio-pop-up/nfo-vedio-pop-up.component';
import { LtefProductDetailComponent } from './ltef-product-detail/ltef-product-detail.component';
import { CeoDeskComponent } from './ceo-desk/ceo-desk.component';
import { CeoDeskMobileComponent } from './ceo-desk/ceo-desk-mobile.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { ArticleCardComponent } from "@component/ceo-desk/articles/article-card.component";
import { GoogleMapsModule } from '@angular/google-maps';
// const DEFAULT_SWIPER_CONFIG: SwiperConfigInterface = {
//   observer: true,
//   direction: "horizontal",
//   threshold: 50,
//   spaceBetween: 5,
//   slidesPerView: 1,
//   centeredSlides: true,
// };

@NgModule({
  declarations: [
    ProductsComponent,
    ContactUsComponent,
    LoginComponent,
    NavDividendsComponent,
    KnowledgeCenterComponent,
    DownloadsComponent,
    CareersComponent,
    BranchesComponent,
    // GrowthMenuComponent,
    NfoComponent,
    CeoDeskComponent,
    CeoDeskMobileComponent,
    ArticleDetailsComponent,
    ArticleDetailsMobileComponent,
    LatestNewsComponent,
    MediaComponent,
    ApplyJobDialogComponent,
    LifeAtXyzComponent,
    VideoPopUpComponent,
    InterviewsComponent,
    AdvertisementComponent,
    CeoLibraryComponent,
    NfoVedioPopUpComponent,
    LtefProductDetailComponent,
    ArticleCardComponent,
  ],
  imports: [
    AppCommonModule,
    ComponentRoutingModule,
    //   DataTableModule,
    //   MyDatePickerModule,
    //   Ng5SliderModule,
    //   TooltipModule,
    //   SwiperModule,
    NgChartsModule,
    //   HighchartsChartModule,
    KeyPolicyModule,
    PopUpsModule,
    NgxPaginationModule,
    GoogleMapsModule
    // AgmCoreModule.forRoot({
    //   apiKey: environment.googleMapKey,
    // })
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],

  providers: [
    // {
    //   provide: SWIPER_CONFIG,
    //   useValue: DEFAULT_SWIPER_CONFIG,
    // },
  ],
})
export class ComponentsModule { }
